import { motion } from "framer-motion";

// Apple-style scroll-triggered fade-up. Wrap any section that should reveal
// as the visitor scrolls into it. Falls back to instant render if motion is
// disabled (framer respects prefers-reduced-motion).
//
// Usage: <SectionReveal as="section" className="...">…</SectionReveal>
const EASE = [0.16, 1, 0.3, 1]; // apple-ish cubic-bezier

const containerVariant = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.08, delayChildren: 0.05 } },
};

const itemVariant = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } },
};

export default function SectionReveal({
  as = "section",
  className = "",
  children,
  once = true,
  amount = 0.2,
  stagger = false,
  ...rest
}) {
  const Motion = motion[as] || motion.section;
  return (
    <Motion
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount, margin: "-80px 0px -80px 0px" }}
      variants={stagger ? containerVariant : itemVariant}
      {...rest}
    >
      {children}
    </Motion>
  );
}

// Companion for staggered children inside a SectionReveal stagger container.
export function RevealItem({ as = "div", className = "", children, ...rest }) {
  const Motion = motion[as] || motion.div;
  return (
    <Motion variants={itemVariant} className={className} {...rest}>
      {children}
    </Motion>
  );
}

export const revealItemVariants = itemVariant;
export const revealContainerVariants = containerVariant;
export const APPLE_EASE = EASE;
